<template>
  <transition name="modal">
    <Modal
      :show="true"
      :classes="{
        modalDialog: 'b24 modal-container modal-clubtimer body_back',
        modalHeader: 'modal__header__paddingless',
        modalBody: 'row feature-block feature-block--border-red w-full',
        modalFooter: 'modal__footer__paddingless',
        modalButton: 'button close',
      }"
      :show-close="true"
      @closed="closeModal"
    >
      <template #body>
        <div class="row feature-blocks">
          <div class="columns">
            <div class="row">
              <div class="columns">
                <CountDown :start-timestamp="date" />
              </div>
            </div>
            <h2>
              Want a 10% credit<br />
              on your last order?
            </h2>
            <div class="row">
              <div class="columns">
                <p class="large">
                  Join a Wine Club and save 10%<br />
                  on all purchases
                </p>
                <p>
                  <nuxt-link
                    to="/club/"
                    class="button button-black"
                    style="text-decoration: none"
                    @click="onClickOut('join_club_10_pct_popup_clicked')"
                  >
                    <span>Find Your Perfect Club</span>
                  </nuxt-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </transition>
</template>
<script>
import ga4 from '#common/utils/ga4'
export default {
  name: 'JoinClub10pctModal',
  components: {
    CountDown: () => import('#common/components/CountDown.vue'),
    Modal: () => import('#common/components/Modal.vue'),
  },
  props: {
    creditAmount: { type: Number, default: 0 },
    date: { type: String, default: Date() },
  },
  emits: ['close'],
  methods: {
    onClickOut(event) {
      ga4.track(event)
    },
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>
